import React, { useState, useEffect } from "react";
import styled from 'styled-components';
import './App.css';
import Header from './components/Header';
import Footer from './components/Footer';
import Landing from "./components/Landing";
import swirl from './images/DailyBruinLogo.svg';
import BannerIllo from './components/BannerIllo';
import ArticleRow from './components/ArticleRow';
import swirl1 from './images/orangeswirl.svg';
import swirl2 from './images/greenswirl.svg';
import swirl3 from './images/blueswirl.svg';
import Description from "./components/Description";

function App() {
  const [ data, setData ] = useState(null);
  
  useEffect(() => {
		fetch("https://kerckhoff.dailybruin.com/api/packages/flatpages/flatpage.2022.opinion.who-are-we")
		.then(res => res.json())
		.then(res => setData(res.data['article.aml']))
  }, [])

  return (
    <div className="App">
      <Header/>
      {data && <Landing landing_image={data.landing_image} landing_credits={data.landing_credits} /> }
      {data && <Description description_text={data.description_text} />}
      {data && <ArticleRow articles={data.section1} background_color={"#F6D7BA"} background_image={swirl1}/>}
      {data && <BannerIllo illo_url={data.banner_illo_1} background_color={"D2D5BD"} credit={data.banner_illo_1_credits}/>}
      {data && <ArticleRow articles={data.section2} background_color={"D2D5BD"} background_image={swirl2}/>}
      {data && <BannerIllo illo_url={data.banner_illo_2} background_color={"C1DFF1"} credit={data.banner_illo_2_credits}/>}
      {data && <ArticleRow articles={data.section3} background_color={"#C1DFF1"} background_image={swirl3}/>}
      

      <Footer/>
    </div>
  );
}

export default App;
